import classnames from 'classnames';
import { NikeSwoosh } from '@nike/nike-design-system-icons';

type ToggleTermProps = {
  title: string;
  isSelected?: boolean;
  className?: string;
  onClick: () => void;
};

export default function ToggleTerm(props: ToggleTermProps) {
  const { title, className = '', isSelected = false, onClick } = props;
  const myClassName = classnames(
    'tw-flex tw-rounded-full tw-text-sm tw-py-1 tw-px-5 tw-cursor-pointer tw-transition-all hover:tw-opacity-75',
    className,
    {
      'tw-bg-gray-100': !isSelected,
      'tw-bg-red-50 tw-text-red-500 tw-font-bold': isSelected,
    },
  );
  return (
    <div className={myClassName} onClick={onClick}>
      {title}
    </div>
  );
}
